import { render, staticRenderFns } from "./packageChoosen.vue?vue&type=template&id=6b7aaf70&"
import script from "./packageChoosen.vue?vue&type=script&lang=js&"
export * from "./packageChoosen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports